import { Component, inject } from '@angular/core';
import { ConditionalForCalculationService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ConditionalForCalculationCreateDto,
  ConditionalForCalculationDto,
  ConditionalForCalculationExcelDownloadDto,
  ConditionalForCalculationUpdateDto,
} from '../proxy/controlling/dtos/conditional-for-calculation';
import { CONDITIONALFORCALCULATION_CONFIG, CONDITIONALFORCALCULATION_FIELDS } from './conditional-for-calculation.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-conditional-for-calculation',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ConditionalForCalculationService, ConfirmationService],
  templateUrl: './conditional-for-calculation.html',
  styleUrl: './conditional-for-calculation.scss',
})
export class ConditionalForCalculation extends BaseCrudComponent<
  ConditionalForCalculationDto,
  ConditionalForCalculationCreateDto,
  ConditionalForCalculationUpdateDto,
  ConditionalForCalculationExcelDownloadDto
> {
  service = inject(ConditionalForCalculationService);
  config = CONDITIONALFORCALCULATION_CONFIG;
  fields = CONDITIONALFORCALCULATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: ConditionalForCalculationDto): ConditionalForCalculationUpdateDto {
    return {
      vehicleTypeId: data.vehicleTypeId,
      validSinceDate: data.validSinceDate,
      grossLessThan: data.grossLessThan,
      tareLessThan: data.tareLessThan,
      tareGreaterThan: data.tareGreaterThan,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ConditionalForCalculation';
  }
}
